
export const encryptPrice = (price: string) => {
  const digits = price.match(/\d/g);
  const encryptedPrice = digits ? `${digits[0]}${'x'.repeat(digits.length - 1)}` : '';
  return encryptedPrice;
};
